module.exports = {"OrderQueue":"Beställningar","InProgress":"Pågående","Ready":"Klar att plocka upp","OrdersInProgress":"Pågående","OrdersReady":"Klar att plocka upp","DisplaySettings":"Skärminställningar","Cancel":"Annullera","Save":"Spara","kitchenServiceAddress":"Kökstjänst värd","UnexpectedPosError":"Oväntat problem! Kontrollera anslutningen!","CheckConnection":"Anslutning med köksservice har misslyckats. Kontrollera skärmkonfigurationen!","Refresh":"Uppdatera","showReadyToPickUpView":"Visa redo att hämta avsnitt","showPreparationView":"Visa i förberedelser sektion"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/sv.json
// module id = 246
// module chunks = 0